export default __webpack_public_path__ + "static/media/P00138022_WF_BRAND_FY25_ISF_AprUpdate21_LP_767x577.920f0360.jpg";